/**
 * Admin — Variants sub-feature manifest.
 *
 * 1 contexte : `admin-evaluation-variant-form` (config d'une variante :
 * graph editor + steps + rules + personas + prompt + ressources).
 * Pas de lien sidebar — accédé depuis admin-evaluation-form.
 */

import { FolderOpen, LayoutList, Pencil, Sparkles } from 'lucide-react';
import { ADMIN_GUARD } from '../admin-guard';
import { CONTEXTS, lazyView, type FeatureManifest } from '@/app/registry';
import { adminVariantsRoutes } from './routes';

export const adminVariantsManifest: FeatureManifest = {
  id: 'admin-variants',
  contexts: [CONTEXTS.ADMIN_EVALUATION_VARIANT_FORM],

  routes: [{ routes: adminVariantsRoutes, errorFallbackLabel: 'Variantes', guard: ADMIN_GUARD }],

  centerView: {
    [CONTEXTS.ADMIN_EVALUATION_VARIANT_FORM]: lazyView(
      () => import('../views/AdminEvaluationVariantFormView'),
      'AdminEvaluationVariantFormView',
    ),
  },

  panels: {
    left: {
      tabs: {
        [CONTEXTS.ADMIN_EVALUATION_VARIANT_FORM]: [
          {
            id: 'admin-nav',
            label: 'Navigation',
            icon: LayoutList,
            view: lazyView(() => import('../views/AdminNavView'), 'AdminNavView'),
          },
        ],
      },
    },
    right: {
      tabs: {
        [CONTEXTS.ADMIN_EVALUATION_VARIANT_FORM]: [
          {
            id: 'variant-prompt',
            label: 'Prompt',
            icon: Sparkles,
            view: lazyView(
              () => import('../views/AdminVariantPromptView'),
              'AdminVariantPromptView',
            ),
          },
          {
            id: 'variant-resources',
            label: 'Ressources',
            icon: FolderOpen,
            view: lazyView(
              () => import('../views/AdminVariantResourcesView'),
              'AdminVariantResourcesView',
            ),
          },
          // Temporairement masqué — à réactiver très prochainement
          // {
          //   id: 'variant-personas',
          //   label: 'Personas',
          //   icon: Users,
          //   view: lazyView(
          //     () => import('../views/AdminVariantPersonasView'),
          //     'AdminVariantPersonasView',
          //   ),
          // },
          {
            id: 'variant-node-edit',
            label: 'Édition',
            icon: Pencil,
            view: lazyView(
              () => import('../views/AdminVariantNodeEditView'),
              'AdminVariantNodeEditView',
            ),
          },
        ],
      },
    },
  },

  enabledWhen: {
    roles: ['admin'],
  },

  panelRequirements: {
    [CONTEXTS.ADMIN_EVALUATION_VARIANT_FORM]: {
      left: { open: true, defaultActiveTab: 'admin-nav' },
      right: { open: true, defaultActiveTab: 'variant-prompt' },
    },
  },
};
